var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDsShowIcon = function SvgDsShowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 5.333a2.667 2.667 0 1 0 0 5.334 2.667 2.667 0 0 0 0-5.334M6.667 8a1.333 1.333 0 1 1 2.666 0 1.333 1.333 0 0 1-2.666 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.308 7.816 14.667 8l.64.184v.003l-.002.005-.005.015a3 3 0 0 1-.075.223 7 7 0 0 1-.248.586 8 8 0 0 1-1.138 1.751c-1.105 1.29-2.947 2.566-5.839 2.566s-4.734-1.277-5.84-2.566a8 8 0 0 1-1.137-1.751A7 7 0 0 1 .7 8.207l-.005-.015-.002-.005v-.003L1.333 8l-.64-.184v-.003l.002-.005.005-.015a3 3 0 0 1 .075-.223c.053-.145.134-.346.248-.586a8 8 0 0 1 1.138-1.751C3.266 3.943 5.108 2.667 8 2.667s4.734 1.276 5.84 2.566c.546.638.91 1.274 1.137 1.751a7 7 0 0 1 .308.758l.015.05.005.016.002.005zM2.226 7.557a6 6 0 0 0-.19.443 6.657 6.657 0 0 0 1.135 1.9C4.069 10.942 5.56 12 8 12s3.932-1.057 4.827-2.1A6.7 6.7 0 0 0 13.962 8a6.656 6.656 0 0 0-1.135-1.9C11.932 5.057 10.441 4 8 4S4.068 5.057 3.173 6.1a6.7 6.7 0 0 0-.946 1.457",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m1.333 8-.64.183L.64 8l.052-.183zM14.667 8l.64-.183.053.183-.052.183z"
  })));
};
export default SvgDsShowIcon;